import { buttonClassNames } from '@spotify-internal/encore-web';

export const transitionActionLinkClassNames = {
  primary: buttonClassNames({
    variant: 'primary',
    size: 'medium',
  }),
  secondary: buttonClassNames({
    variant: 'secondary',
    size: 'medium',
  }),
};
